var getLocalizedDisplayText = function (message, languages) {
    var _a, _b;
    var getDisplayText = function (lng) { return message.displayTexts.find(function (it) { return it.language.toLowerCase() === lng; }); };
    var preferredLanguages = (Array.isArray(languages) ? languages : [languages]).map(function (lng) {
        return lng.toLowerCase().slice(0, 2);
    });
    for (var _i = 0, preferredLanguages_1 = preferredLanguages; _i < preferredLanguages_1.length; _i++) {
        var lng = preferredLanguages_1[_i];
        var displayText = getDisplayText(lng);
        if (displayText) {
            return displayText;
        }
    }
    return (_b = (_a = getDisplayText('en')) !== null && _a !== void 0 ? _a : getDisplayText('de')) !== null && _b !== void 0 ? _b : message.displayTexts[0];
};
export var MessageUtils = {
    getLocalizedDisplayText: getLocalizedDisplayText,
};
